import AppointmentMain from "../../../components/Appointments/AppointmentMain";

export default function index() {
  return (
    <>
      <AppointmentMain />
    </>
  );
}
